module.exports = __webpack_public_path__ + "img/dispose14.c2043325.png";